<template>
  <div class="login-form">
    <div class="login-form__item">
      <div class="login-form__group">
        <span class="login-form__icon">
          <i class="fa fa-user"></i>
        </span>
        <input
          type="text"
          name="mobile"
          v-model="login.mobile"
          autocomplete="off"
          class="login-form__input"
          placeholder="请输入账号"
        />
      </div>
    </div>

    <div class="login-form__item login-form__item--password">
      <div class="login-form__group">
        <span class="login-form__icon">
          <i class="fa fa-lock"></i>
        </span>
        <input
          type="password"
          name="password"
          v-model="login.password"
          @keyup.enter="submit"
          autocomplete="off"
          class="login-form__input"
          placeholder="请输入密码"
        />
      </div>
    </div>

    <div class="login-form__options">
      <span class="login-form__forgot" @click="$emit('input', 'ForgotPassword')">忘记密码</span>
    </div>

    <div class="login-form__submit">
      <Button
        block
        color="primary"
        size="l"
        :disabled="loading"
        class="login-form__button"
        @click="submit"
      >
        <i v-if="loading" class="h-icon-spinner login-form__button-loading"></i>
        <span>{{ loading ? "登录中" : "登 录" }}</span>
      </Button>
    </div>

    <div class="login-form__footer">
      <span class="login-form__footer-text">还没账号，</span>
      <span class="login-form__register" @click="$emit('input', 'Registered')">注册账号</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "LoginForm",
  data() {
    return {
      login: {
        mobile: "",
        password: ""
      },
      loading: false
    };
  },
  methods: {
    submit() {
      if (this.loading) {
        return;
      }
      if (this.login.mobile && this.login.password) {
        this.loading = true;
        this.$api.common.login(this.login).then(() => {
          this.$store.dispatch('bootstrap', { force: true }).finally(() => {
            this.$router.replace(this.$route.query.redirect || { name: 'Office' });
          });
        }).catch(() => {
          this.loading = false;
        });
      }
    }
  }
};
</script>

<style lang="less">
@primary: #3c72ff;
@primary-dark: #2e63ec;
@line-color: #dcdfe6;
@icon-color: #909399;
@text-main: #303133;
@text-sub: #909399;

.login-form {
  width: 100%;
}

.login-form__item + .login-form__item {
  margin-top: 16px;
}

.login-form__group {
  display: flex;
  align-items: center;
  height: 42px;
  border: 1px solid @line-color;
  border-radius: 4px;
  background: #fff;
  box-sizing: border-box;
}

.login-form__icon {
  width: 42px;
  height: 100%;
  flex: none;
  display: flex;
  align-items: center;
  justify-content: center;
  color: @icon-color;
  font-size: 14px;
  border-right: 1px solid #ebeef5;
}

.login-form__input {
  width: 100%;
  height: 100%;
  border: 0;
  outline: none;
  padding: 0 12px;
  color: @text-main;
  font-size: 14px;
  background: #fff;
  box-sizing: border-box;
  border-radius: 4px;
}

.login-form__input::placeholder {
  color: #c0c4cc;
}

.login-form__options {
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
}

.login-form__forgot {
  color: @text-sub;
  font-size: 14px;
  cursor: pointer;
}

.login-form__forgot:hover {
  color: @primary;
}

.login-form__submit {
  margin-top: 20px;
}

.login-form__button,
.login-form__button.h-btn,
.login-form__button.h-btn-primary {
  width: 100%;
  height: 42px;
  border: none;
  border-radius: 4px;
  background: @primary;
  color: #fff;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 8px;
  box-shadow: none;
}

.login-form__button span {
  display: inline-flex;
  align-items: center;
}

.login-form__button-loading {
  margin-right: 8px;
  font-size: 14px;
}

.login-form__button:hover,
.login-form__button:focus,
.login-form__button.h-btn:hover,
.login-form__button.h-btn-primary:hover {
  background: @primary-dark;
  color: #fff;
}

.login-form__button[disabled],
.login-form__button.h-btn[disabled] {
  opacity: 1;
  background: @primary;
  color: #fff;
}

.login-form__footer {
  margin-top: 32px;
  text-align: center;
  font-size: 14px;
}

.login-form__footer-text {
  color: @text-sub;
}

.login-form__register {
  color: @primary;
  cursor: pointer;
  font-weight: 500;
}

.login-form__register:hover {
  color: @primary-dark;
}

@media (max-width: 760px) {
  .login-form__submit {
    margin-top: 16px;
  }
}
</style>
